<template>
    <div class="card-list" ref="card_list">
        <label class="title">{{title}}</label>
        <i v-if="icon" class="i-settings" @click="$emit('titleFunc', item)"></i>
        <div class="list-scroller">
            <div class="list">
                <template v-if="list.length > 0 && list[0].name != undefined">
                    <div v-for="(item, k) in list" :key="item.name" class="card" :class="[{'disabled': item.route == 'none'}, {'hidden': !hasPermission(item.permissions)}]">
                        <img v-if="item.data != null && item.data.image" :src="item.data.image">
                        <fyi-logo :card="true" v-else />
                        <i v-if="icon" class="i-settings" @click="() => { item.func(item.id)}"></i>
                        <label class="card-name">{{item.name}}</label>
                        <label class="card-type">{{item.type.name}}</label>
                        <div class="enter" @click="$emit('appEnter', item)">
                            <span>{{$t('enter')}}</span>
                        </div>
                    </div>
                </template>
                <template v-if="list.length > 0 && list[0].label != undefined">
                    <div v-for="(item, k) in list" :key="item.label" class="card" :class="[{'disabled': item.route == 'none'}, {'hidden': !hasPermission(item.permissions)}]">
                        <i :class="['preview-icon', item.icon]"></i>
                        <label class="card-name">{{item.label}}</label>
                        <div class="enter" @click="$router.push({name: item.route, params: item.params, query: item.query})">
                            <span>{{item.buttonLabel}}</span>
                        </div>
                    </div>
                </template>
                <div v-if="list.length == 0 & !loading" class="card empty">
                    <label>{{$t('no_app')}}</label>
                </div>
                <div v-if="loading" class="loading-animation">
                    {{loader}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"CardList",
    data: () =>{
        return {

        }
    },
    props: {
        title: {
            type: String,
            default: ""
        },
        list: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        icon : {
            type: Boolean,
            default: true
        },
    },
    computed: {
        loader(){
            const _this = this;
            setTimeout(() => {   
                _this.$refs.card_list.querySelector(".loading-animation").innerHTML = "";
				bodymovin.loadAnimation({
					container: _this.$refs.card_list.querySelector('.loading-animation'),
					animationData: 				{"v":"5.5.2","fr":29.9700012207031,"ip":0,"op":30.0000012219251,"w":2134,"h":2134,"nm":"Layer 2","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":2,"ty":4,"nm":"1 to 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[766,536,0],"to":[689.667,-416.667,0],"ti":[66.333,-391.333,0]},{"t":30.0000012219251,"s":[1823,1069,0]}],"ix":2},"a":{"a":0,"k":[756,2,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,-10.997]},"t":0,"s":[291,291,100]},{"t":30.0000012219251,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[146.453,146.453],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[756.062,1.645],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[102.889,102.889],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300.00001221925,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"1 to 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[792,1535,0],"to":[-450.907,-496.349,0],"ti":[4.167,0,0]},{"t":30.0000012219251,"s":[766,536,0]}],"ix":2},"a":{"a":0,"k":[756,2,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,0.099]},"t":0,"s":[401,401,100]},{"t":30.0000012219251,"s":[291,291,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[146.453,146.453],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[756.062,1.645],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[102.889,102.889],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300.00001221925,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"1 to 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[1823,1069,0],"to":[11.333,260.667,0],"ti":[656.667,363.333,0]},{"t":30.0000012219251,"s":[792,1535,0]}],"ix":2},"a":{"a":0,"k":[756,2,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,-0.041]},"t":0,"s":[100,100,100]},{"t":30.0000012219251,"s":[401,401,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[146.453,146.453],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.22745098039215686,0.7176470588235294,0.8313725490196079,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[756.062,1.645],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[102.889,102.889],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300.00001221925,"st":0,"bm":0}],"markers":[]},
					renderer: 'svg',
					loop: true,
					autoplay: true
				});
			}, 100);
        }
    },
    methods: {
        hasPermission(menu_permission) {
            let permissions = this.$store.getters.auth.permissions;

            if(menu_permission == null || menu_permission == undefined){
                return true;
            }else if(permissions.includes("all")){
                return true
            }else{
                let flag = 0;
                permissions.forEach(p => {
                    if(menu_permission.some(item => item == p.split(".")[0])){
                        flag++;
                    }
                });

                return flag == menu_permission.length
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "../../../../styles/components/layout/card_list.scss";
</style>